/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {
  defaultErrorValues,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Assurance/assuranceRCVP';
import {IError} from '../../data/types/interface/Assurance/assuranceRCVP';

export const useForm = (
  data: any,
  Validate: any,
  handleSave: any,
  listAgence?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultErrorValues);

  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    setValues({...values, [name]: value});
  };

  const noError = () => {
    let bNoError = true;
    Object.values(errors).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setErrors(Validate(values, listAgence));
    if (noError()) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto};
};
